import "./App.css";
import React, { useState, useEffect } from "react";
import { Route, Routes, BrowserRouter } from "react-router-dom";

import Loader from "./components/ui/Loader";

// Protected
import ProtectedRoute from "./routes/ProtectedRoute";
import MainProfile from "./layouts/MainProfile";

// Public
import Home from "./pages/public/Home";
import LoginPage from "./pages/auth/LoginPage";

// Admin
import AdminPage from "./pages/admin/AdminPage";
import AdminSubject from "./pages/admin/AdminSubject";
import MainPageControl from "./pages/admin/MainPageControl";
import Register from "./pages/admin/Register";
import UsersControl from "./pages/admin/AdminUsers";

// Teacher
import TeacherPage from "./pages/teacher/TeacherPage";
import SubjectsIntro from "./pages/teacher/SubjectsIntro";
import TestsPage from "./pages/teacher/TestPage";
import AddTestPage from "./pages/teacher/AddTestModal";
import AddQuestionPage from "./pages/teacher/AddQuestionPage";
import ResultsPage from "./pages/teacher/ResultsPage";
import ResultTable from "components/layout/ResultsTable";
import DocumentsPage from "./pages/teacher/DocumentsPage";
import StudentAddPage from "./pages/teacher/StudentAddPage";
import TestDetailPage from "./components/layout/TestDetailPage";
import AddDocumentForm from "./components/common/AddDocumentForm";

// Student
import StudentPage from "./pages/student/StudentPage";
import StudentTestPage from "./pages/student/StudentTestPage";
import StudentSubjectsIntro from "./pages/student/StudentSubjectIntro";
import StudentResultPage from "./pages/student/StudentResultsPage";
import StudentResultTablePage from "./pages/student/StudentResultTablePage";
import StudentDocPage from "./pages/student/StudentDocPage";
import { StudentTestInfoPage } from "./pages/student/StudentTestInfoPage";
import StudentTestStart from "./pages/student/StudentTestStartPage";
import Profile from "./pages/student/Profile";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1500);
    return () => clearTimeout(timer);
  }, []);

  if (loading) return <Loader />;

  return (
    <BrowserRouter>
      <Routes>
        {/* PUBLIC ROUTES */}
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/profile"
          element={
            <ProtectedRoute
              allowedRoles={["admin", "administrator", "teacher", "student"]}
            >
              <MainProfile />
            </ProtectedRoute>
          }
        />

        {/* ================== ADMIN ================== */}
        <Route
          path="/admin"
          element={
            <ProtectedRoute allowedRoles={["admin", "administrator"]}>
              <AdminPage />
            </ProtectedRoute>
          }
        >
          <Route path="main" element={<MainPageControl />} />
          <Route path="users" element={<UsersControl />} />
          <Route path="subjects" element={<AdminSubject />} />
          <Route path="student_add" element={<Register />} />
        </Route>

        {/* ================== TEACHER ================== */}
        <Route
          path="/teacher"
          element={
            <ProtectedRoute allowedRoles={["teacher"]}>
              <TeacherPage />
            </ProtectedRoute>
          }
        >
          <Route index element={null} />

          <Route path="subject/:slug" element={<SubjectsIntro />} />

          <Route path="tests" element={<TestsPage />} />

          <Route path="add-test" element={<AddTestPage />} />

          <Route path="test/:slug" element={<TestDetailPage />} />

          <Route path="add-questions" element={<AddQuestionPage />} />

          <Route path="results" element={<ResultsPage />} />
          <Route path="result-table/:id" element={<ResultTable />} />

          <Route path="docs" element={<DocumentsPage />} />
          <Route path="add-document" element={<AddDocumentForm />} />

          <Route path="students/add" element={<StudentAddPage />} />
        </Route>

        {/* ================== STUDENT ================== */}
        <Route
          path="/student"
          element={
            <ProtectedRoute allowedRoles={["student"]}>
              <StudentPage />
            </ProtectedRoute>
          }
        >
          <Route index element={null} />
          <Route path="subject/:name" element={<StudentSubjectsIntro />} />
          <Route path="tests" element={<StudentTestPage />} />
          <Route path="test/start" element={<StudentTestStart />} />
          <Route path="results" element={<StudentResultPage />} />
          <Route path="result-table/:id" element={<StudentResultTablePage />} />
          <Route path="docs" element={<StudentDocPage />} />
          <Route path="test/info/:id" element={<StudentTestInfoPage />} />
          <Route path="profile" element={<Profile />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
